import { render } from "./Unauthorised.vue?vue&type=template&id=d759606e&scoped=true"
import script from "./Unauthorised.vue?vue&type=script&lang=js"
export * from "./Unauthorised.vue?vue&type=script&lang=js"

import "./Unauthorised.vue?vue&type=style&index=0&id=d759606e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d759606e"]])

export default __exports__